export default __webpack_public_path__ + "static/media/partner_sale.92553243.png";